module.exports = __webpack_public_path__ + "img/terms-pdf-4.0066cdf8.jpg";